module.exports = __webpack_public_path__ + "img/3P_Funding_logo.2b60f6a3.png";